import { Component, OnInit } from '@angular/core';
import { NgIf, DatePipe } from '@angular/common';

@Component({
    selector: 'app-insight-websocket-window',
    templateUrl: './insight-websocket-window.component.html',
    styleUrls: ['./insight-websocket-window.component.scss'],
    imports: [NgIf, DatePipe]
})
export class InsightWebsocketWindowComponent implements OnInit {
  public results;

  constructor() { }

  public ngOnInit() {
  }
}
